<script>
  import SEO from "$lib/components/SEO.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import { afterUpdate, setContext, onMount, getContext } from "svelte";
  import { datadogLogs } from "@datadog/browser-logs";
  import EventOrderDetails from "$lib/components/EventConfirmation/EventOrderDetails.svelte";
  import Section from "$lib/components/Section.svelte";
  import { ScheduleCardList, EventGrid } from "@ObamaFoundation/of-design-system";
  import { heroThemeStore } from "$lib/stores.js";
  import HeroConfirmation from "$lib/components/EventConfirmation/HeroConfirmation.svelte";
  import { getRelatedLists } from "$lib/utilities/eventSchedule.js";
  import { gtag } from "$lib/utilities/gtm.js";

  export let data;
  const featureFlags = getContext("featureFlags") ?? {};
  const displayTours = featureFlags.confirmationPageTours;
  const displayEvents = featureFlags.confirmationPageEvents;
  const { entry, ipls, orderData, isLoading, orderIds } = data;
  heroThemeStore.set("white");
  $: isEmptyOrder = !orderData || !orderData.tickets || orderData.tickets.length === 0;

  const { relatedTours, relatedEvents, orderType, tickets, orderNumbers } = orderData || {};

  // Related tours/events data transformation
  let { relatedToursData, relatedEventsData } = getRelatedLists(
    relatedTours?.tours || [],
    relatedEvents?.events || []
  );

  const trailingBody = entry.fields.trailingBody;
  const mainBody = entry.fields.body;

  setContext("ipls", ipls);

  afterUpdate(() => {
    if (!isLoading && isEmptyOrder) {
      datadogLogs.logger.info(`No order found for order ID(s) ${orderIds.join(" and ")}`);
    }
  });

  onMount(async () => {
    gtag("event", "page_view", {
      page_title: "Confirmation",
      page_location: location.href
    });
  });
</script>

<SEO
  data={{
    headline: "Order Confirmation",
    description: "Your order confirmation details."
  }}
  noIndex={true}
  noFollow={true}
/>

{#if isLoading}
  <div class="">
    <HeroConfirmation title={"Collecting your order details..."} isLoading />
  </div>
{:else}
  {#if !isLoading && orderIds && isEmptyOrder}
    <div class="">
      <HeroConfirmation title={"Order Confirmed"} subtitle={"Tickets are headed to your email."} />
    </div>
  {/if}

  {#if !isEmptyOrder}
    <div class="mb-15 md:mb-20 lg:mb-25">
      <EventOrderDetails {orderType} {tickets} confirmationNumber={orderNumbers[0]} />
    </div>
  {/if}

  {#if displayTours && relatedTours?.tours?.length > 0}
    <ScheduleCardList
      days={[
        {
          title: relatedTours.title,
          date: "2025-12-04",
          items: relatedToursData
        }
      ]}
    />
  {/if}

  {#if displayEvents && relatedEvents?.events?.length > 0}
    <Section
      class="embedded-content"
      title={relatedEvents.title}
      cta={{
        text: "Full Event Calendar",
        url: "/whats-on/"
      }}
    >
      <EventGrid items={relatedEventsData} />
    </Section>
  {/if}

  <PageBody body={mainBody} class="page-body {trailingBody ? '' : 'last-page-element'}" />

  {#if trailingBody}
    <PageBody body={trailingBody} class="page-body last-page-element" />
  {/if}
{/if}
